module.exports = __webpack_public_path__ + "static/media/empty_shop_logo.44111240.svg";